import React from 'react';

import { Tooltip } from '@mui/material';

import { useIsTextTruncated } from 'hooks/useIsTextTruncated';

type TruncatedTextProps<T extends HTMLElement> = {
  text: string;
  children: (ref: React.RefObject<T>) => React.ReactElement;
};

const TOOLTIP_ENTER_DELAY = 400;

const TruncatedText = <T extends HTMLElement>({ text, children }: TruncatedTextProps<T>): React.ReactElement => {
  const textRef = React.useRef<T>(null);
  const { isTruncated, measure } = useIsTextTruncated(textRef);

  return (
    <Tooltip title={isTruncated ? text : ''} enterDelay={TOOLTIP_ENTER_DELAY} onOpen={measure}>
      {children(textRef)}
    </Tooltip>
  );
};

export default TruncatedText;
